import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    Observable,
    catchError, throwError
} from 'rxjs';
import { IAppConfig } from '../interfaces/app-config';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ContributorRequest } from '../models/add-contributor.model';
import { IIepStaff } from 'src/app/modules/iep/iep-document/interfaces/iep-staff';
import { SubmitContributorData } from '../models/submit-contributor.model';
import { SubmitProgressReportContributorData } from '../models/submit-progress-report-contributor.model';
import { SubmitCancelMeetingModel } from '../models/cancel-meeting-model/submit-cancel-meeting-model';
import { SubmitCloseRequestExtensiongModel } from '../models/close-request-extension/submit-close-request-extension-model';
import { SubmitSudentRelatedEventsModel } from '../models/student-related-events-models/submit-student-related-event-model';
import { SubmitCaseClosingModel } from '../models/case-close-model/submit-case-close-model';
import { CancelMeeting } from 'src/app/modules/evaluations/interfaces/cancel-meeting';
import { SudentRelatedEventsModel } from '../models/student-related-events-models/student-related-event-response-model';
import { ApiResponse } from '../interfaces/api-response';
import { assertTrustedUrl } from '../functions/validate-url';

@Injectable({
    providedIn: 'root'
})
export class ContributorService {
    config: IAppConfig;

    public isEditingStudentInfo$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {
        this.config = this.appConfigService.getConfig();
    }
    public getContributors(dbn: string): Observable<IIepStaff[]> {
        const url = assertTrustedUrl(
            `${this.config.studentApiUrl}/Staff/Search/${encodeURIComponent(dbn)}`,
            this.config.studentApiUrl
        );
        return this.http
            .get<IIepStaff[]>(url)
            .pipe(catchError(this.handleError));
    }

    public submit(request: SubmitContributorData[]): Observable<ContributorRequest[]> {
        return this.http.post<ContributorRequest[]>(`${this.config.apiUrl}/Contributor/AddContributor`, request)
            .pipe(catchError(this.handleError));
    }

    public submitProgressReportContributors(
        request: SubmitProgressReportContributorData[]
    ): Observable<ContributorRequest[]> {
        return this.http
            .post<ContributorRequest[]>(`${this.config.apiUrl}/ProgressReport/AddContributor`, request)
            .pipe(catchError(this.handleError));
    }
    // Error handling
    handleError(error: any) {
        let errorMessage: string = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        //window.alert(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }

    public submitCancelMeetingRequest(request: SubmitCancelMeetingModel): Observable<CancelMeeting> {
        return this.http.put<CancelMeeting>(`${this.config.studentApiUrl}/Meeting/CancelMeeting`, request)
            .pipe(catchError(this.handleError));
    }
    public submitCloseRequestExtensiongRequest(request: SubmitCloseRequestExtensiongModel): Observable<void> {
        return this.http.put<void>(`${this.config.studentApiUrl}/Meeting/CancelMeeting`, request)
            .pipe(catchError(this.handleError));
    }
    public submitStudentRelatedEvent(request: SubmitSudentRelatedEventsModel): Observable<SudentRelatedEventsModel> {
        return this.http.post<SudentRelatedEventsModel>(`${this.config.studentApiUrl}/EventLog/Add`, request)
            .pipe(catchError(this.handleError));
    }
    public submitCaseCloseEvent(request: SubmitCaseClosingModel): Observable<SudentRelatedEventsModel> {
        return this.http.post<SudentRelatedEventsModel>(`${this.config.apiUrl}/CaseClose/Add`, request)
            .pipe(catchError(this.handleError));
    }

    public getUserEvents(id: string): Observable<ApiResponse<SudentRelatedEventsModel>> {
        return this.http
            .get<ApiResponse<SudentRelatedEventsModel>>(`${this.config.studentApiUrl}/EventLog/UserEventLogs?caseactionSk=` + id)
            .pipe(catchError(this.handleError));
    }

    public submitTwelveMonthRequest(request: SubmitCancelMeetingModel): Observable<void> {
        return this.http.put<void>(`${this.config.studentApiUrl}/Meeting/CancelMeeting`, request)
            .pipe(catchError(this.handleError));
    }
}
